module.exports = __webpack_public_path__ + "img/bitbox.6a65708e.jpg";